import { ButtonHTMLAttributes } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  title: string;
  variant?: "primary" | "secondary";
}

const Button = ({ title, variant = "primary", ...props }: ButtonProps) => {
  const baseStyles = "w-full p-2 rounded font-semibold transition";
  const variants = {
    primary: "bg-blue-500 text-white hover:bg-blue-600",
    secondary: "bg-gray-200 text-black hover:bg-gray-300",
  };

  return (
    <button
      {...props}
      className={`${baseStyles} ${variants[variant]} ${props.className || ""}`}
    >
      {title}
    </button>
  );
};

export default Button;
